<template>
  <div class="video-container">

    <video id="myVideo" loop muted data-autoplay playsinline>
      <source src="/cg2.mp4" type="video/mp4">
    </video>

    <div class="intro">
      <div>
        <h1 :class="{'fadeInDown': sectionsIndex == 0}"><img src="../../assets/images/slogan.png" alt=""></h1>
        <!-- <p :class="{'fadeInUp': sectionsIndex==0}">SEE THE FUTURE WITH AI</p> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['sectionsIndex']
}
</script>

<style lang="scss"></style>
